import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';

import { map, Observable, take } from 'rxjs';

import { DefaultPage } from '@shared/restaurant/enums';
import { AuthRestaurantService } from '@tablesready/frontend-store';

@Injectable({ providedIn: 'root' })
export class DefaultPageGuard implements CanActivate {
  constructor(
    private readonly router: Router,
    private readonly authRestaurantService: AuthRestaurantService,
  ) {}

  canActivate(): Observable<UrlTree> {
    return this.authRestaurantService.select()
      .pipe(
        take(1),
        map(user => {
          if (user.location) {
            try {
              let navigatePath = '/waitlist';
              if (user.location.publicWaitlist.defaultPage === DefaultPage.reservation) {
                navigatePath = '/reservations';
              } else if (user.location.publicWaitlist.defaultPage === DefaultPage.floorPlan && user.account.features.floorPlan) {
                navigatePath = '/floorplan';
              }

              return this.router.parseUrl(navigatePath);
            } catch (err) {
              return this.router.parseUrl('/settings/account/profile');
            }
          }

          return this.router.parseUrl('/settings/account/profile');
        }),
      );
  }
}
